import { DETAILS_DATA_TYPES } from 'store/details/utils/constants';
import isErrorResponse from 'store/details/utils/isErrorResponse';
import isVodEditorialsResponse from 'store/details/utils/isVodEditorialsResponse';
import requestAssetDetailsData from 'store/details/utils/requestAssetDetailsData';

import { VodEditorial } from 'services/data-manager/types.ts';

type Props = {
    id: string | undefined;
};

export type LoadVODDataReturnType = VodEditorial | undefined;

async function loadVODData({ id }: Props): Promise<LoadVODDataReturnType> {
    if (!id) {
        throw new Error('There is no ID provided for current VOD asset');
    }

    const vodDataResponse = await requestAssetDetailsData({
        type: DETAILS_DATA_TYPES.VOD,
        id,
    });

    if (isErrorResponse(vodDataResponse)) {
        throw new Error(vodDataResponse.data.error.message);
    }

    if (!isVodEditorialsResponse(vodDataResponse)) {
        throw new Error('VOD details response format is wrong');
    }

    const {
        data: { editorials },
    } = vodDataResponse;

    if (editorials) {
        if (!editorials.length) {
            throw new Error('No editorial found!');
        }

        if (editorials.length > 1) {
            throw new Error('More than 1 editorial found!');
        }
    }

    return editorials[0];
}

export default loadVODData;
